module.exports = __webpack_public_path__ + "static/media/pulseIcon.svg";